import type { ConsentKitConfig } from "../types";

/**
 * Bumped by the library when the stored record shape changes. Raised to 2 when records
 * gained `region` / `regime` / `gpc`: a record without them cannot say which regime it was
 * made under, and `loadRecord` rejects the mismatch, so every visitor is asked once more.
 */
export const RECORD_VERSION = 2;

export const VERSION = "0.2.0";

export const DEFAULT_CONFIG: ConsentKitConfig = {
  vendors: [],
  // EU by default. Existing embedders keep the exact behaviour they had, and a site owner
  // who never thinks about this setting gets the stricter of the two regimes.
  region: "eu",
  optOutCategories: ["marketing"],
  honorGpc: true,
  customBlocklist: [],
  allowlist: [],
  blocking: "known-vendors",
  categories: { enabled: ["functional", "analytics", "marketing"] },
  theme: { preset: "porcelain", scheme: "auto" },
  layout: "box",
  position: "bottom-left",
  compact: false,
  locale: "auto",
  controller: {},
  consentLifetimeDays: 365,
  configVersion: "1",
  cookieName: "ck_consent",
  revisitButton: true,
  alwaysShowBanner: false,
  reloadOnRevoke: true,
  shadowDom: true,
  debug: false,
};
